import { defineStore } from "pinia";
import axios from "axios";
import { piniaPlugin } from "../../index";

export const useDownloadStore = defineStore("download", {
    state: () => ({
        store: piniaPlugin()
    }),
    getters: {},
    actions: {
        downloadFoldersFiles(id = null, item = {}) {
            this.store.useMultiSelect.showTopProgress = true;
            axios
                .post(
                    route("prepare-to-download"),
                    {
                        items: id !== null ? [{ id: id, dataType: item.dataType, type: item.type }] : this.store.useMultiSelect.selectedItems
                    },
                    { responseType: "blob" }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "Seqwens_Documents.zip";
                    link.click();
                    URL.revokeObjectURL(url);
                    this.store.useMultiSelect.showTopProgress = false;
                    this.store.useMultiSelect.resetOnComponentUpdate();
                })
                .catch(async err => {
                    if (err.response.status === 401) {
                        const result = await this.parseBlobAsJson(err.response.data);
                        this.store.useMultiSelect.toast = {
                            isSuccess: result.success,
                            successMsg: result.message,
                            isToastMessage: true,
                        };
                    }
                    this.store.useMultiSelect.showTopProgress = false;
                });
        },
        parseBlobAsJson(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const jsonData = JSON.parse(reader.result);
                        resolve(jsonData);
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = reject;
                reader.readAsText(blob);
            });
        }
    },
});